import useTypedContext from "hooks/useTypedContext";
import useTypedFlags from "hooks/useTypedFlags";
import { SettingsContext } from "views/Account/Settings/Context";

const useIsNonRootApiKeyManagementEnabled = (): boolean => {
  const { enableApiKeyCreationForNonRootAdminsFrontend, personalApiKeys } = useTypedFlags();
  const { apiKeysManagedByNonRootAdmins } = useTypedContext(SettingsContext);

  return (
    personalApiKeys && enableApiKeyCreationForNonRootAdminsFrontend && apiKeysManagedByNonRootAdmins
  );
};

export default useIsNonRootApiKeyManagementEnabled;
